import pdf from 'vue-pdf'

import firebase from 'firebase'

import 'materialize-css/dist/css/materialize.min.css'

import { store } from './../store/store.js'

export default {
     components: {
          pdf: pdf,
     },     
     data() {
          return {

               pdfList: [
                    'https://firebasestorage.googleapis.com/v0/b/topcg-95de7.appspot.com/o/cvs%2Fcv8.pdf?alt=media&token=b071d36d-b1fe-44ed-99f2-0a95a7ede5ed',
                    'https://firebasestorage.googleapis.com/v0/b/topcg-95de7.appspot.com/o/cvs%2FJCJA-CV%202018.pdf?alt=media&token=33d6b4d1-e050-4f54-83ce-01ea8aba6c1c',
                    'https://firebasestorage.googleapis.com/v0/b/topcg-95de7.appspot.com/o/cvs%2Ftav_AlfredoPa.pdf?alt=media&token=ed7fdc14-0882-4290-bea2-7d94ea70b1fb',
                    'https://cdn.mozilla.net/pdfjs/tracemonkey.pdf',
                    'https://cdn.rawgit.com/mozilla/pdf.js/c6e8ca86/test/pdfs/freeculture.pdf',
                    'https://cdn.rawgit.com/mozilla/pdf.js/c6e8ca86/test/pdfs/annotation-link-text-popup.pdf',
                    'https://cdn.rawgit.com/mozilla/pdf.js/c6e8ca86/test/pdfs/calrgb.pdf',
                    'https://cdn.rawgit.com/sayanee/angularjs-pdf/68066e85/example/pdf/relativity.protected.pdf',
                    'data:application/pdf;base64,JVBERi0xLjUKJbXtrvsKMyAwIG9iago8PCAvTGVuZ3RoIDQgMCBSCiAgIC9GaWx0ZXIgL0ZsYXRlRGVjb2RlCj4+CnN0cmVhbQp4nE2NuwoCQQxF+/mK+wMbk5lkHl+wIFislmIhPhYEi10Lf9/MVgZCAufmZAkMppJ6+ZLUuFWsM3ZXxvzpFNaMYjEriqpCtbZSBOsDzw0zjqPHZYtTrEmz4eto7/0K54t7GfegOGCBbBdDH3+y2zsMsVERc9SoRkXORqKGJupS6/9OmMIUfgypJL4KZW5kc3RyZWFtCmVuZG9iago0IDAgb2JqCiAgIDEzOAplbmRvYmoKMiAwIG9iago8PAogICAvRXh0R1N0YXRlIDw8CiAgICAgIC9hMCA8PCAvQ0EgMC42MTE5ODcgL2NhIDAuNjExOTg3ID4+CiAgICAgIC9hMSA8PCAvQ0EgMSAvY2EgMSA+PgogICA+Pgo+PgplbmRvYmoKNSAwIG9iago8PCAvVHlwZSAvUGFnZQogICAvUGFyZW50IDEgMCBSCiAgIC9NZWRpYUJveCBbIDAgMCA1OTUuMjc1NTc0IDg0MS44ODk3NzEgXQogICAvQ29udGVudHMgMyAwIFIKICAgL0dyb3VwIDw8CiAgICAgIC9UeXBlIC9Hcm91cAogICAgICAvUyAvVHJhbnNwYXJlbmN5CiAgICAgIC9DUyAvRGV2aWNlUkdCCiAgID4+CiAgIC9SZXNvdXJjZXMgMiAwIFIKPj4KZW5kb2JqCjEgMCBvYmoKPDwgL1R5cGUgL1BhZ2VzCiAgIC9LaWRzIFsgNSAwIFIgXQogICAvQ291bnQgMQo+PgplbmRvYmoKNiAwIG9iago8PCAvQ3JlYXRvciAoY2Fpcm8gMS4xMS4yIChodHRwOi8vY2Fpcm9ncmFwaGljcy5vcmcpKQogICAvUHJvZHVjZXIgKGNhaXJvIDEuMTEuMiAoaHR0cDovL2NhaXJvZ3JhcGhpY3Mub3JnKSkKPj4KZW5kb2JqCjcgMCBvYmoKPDwgL1R5cGUgL0NhdGFsb2cKICAgL1BhZ2VzIDEgMCBSCj4+CmVuZG9iagp4cmVmCjAgOAowMDAwMDAwMDAwIDY1NTM1IGYgCjAwMDAwMDA1ODAgMDAwMDAgbiAKMDAwMDAwMDI1MiAwMDAwMCBuIAowMDAwMDAwMDE1IDAwMDAwIG4gCjAwMDAwMDAyMzAgMDAwMDAgbiAKMDAwMDAwMDM2NiAwMDAwMCBuIAowMDAwMDAwNjQ1IDAwMDAwIG4gCjAwMDAwMDA3NzIgMDAwMDAgbiAKdHJhaWxlcgo8PCAvU2l6ZSA4CiAgIC9Sb290IDcgMCBSCiAgIC9JbmZvIDYgMCBSCj4+CnN0YXJ0eHJlZgo4MjQKJSVFT0YK',
               ],
               show:true,
               src: '',
               loadedRatio: 0,
               page: 1,
               numPages: 0,
               rotate: 0,


               /** Para la busqueda y manejo de foto y cvs */
               /** ./cvdocente.pdf */
               urlfoto: "", urlcv: "",
               currFoto: "", currCV: "./cvdocente.pdf",
               currFotoT: "",

               CVs: [],
               selectedFile: "",
               selectedFoto: "",

               /** Datos del participante */
               nombre: "", direccion: "", movil: "", email: "", sexo: "",
               edad: 0, profesion: "", puesto: "", ecivil: "",

               /** Otros */
               busqueda: "",
               mostrarCargador: false,
               porcentaje: 0,
               exito: false,

               profesiones: [
                    'Ingeniero Civil',
                    'Ingeniero Electrónico',
                    'Ingeniero en Informática',
                    'Licenciado(a) en Administración de Empresas',
                    'Licenciado(a) en Pedagogía',
                    'Licenciado en Auditoría',
                    'Obrero'
               ],
               puestos: [
                    'Gerente General',
                    'Gerente Financiero',
                    'Gerente Informática',
                    'Secretaria',
                    'Conserje'
               ],
               estadocivil:[
                    'Casado',
                    'Soltero',
                    'Viudo',
                    'Unido'
               ],
          }
     },
     /** Para usar pdfvuer descomentarizar esta linea de codigo y el watch */
     mounted() {

          var elems = document.querySelectorAll('select');
          var instances = M.FormSelect.init(elems, {});

          /** Definiciones para el uso de los slides y tooltips */
          var elems = document.querySelectorAll('.collapsible');
          var instances = M.Collapsible.init(elems, {});

          var elems = document.querySelectorAll('.tooltipped');
          var instances = M.Tooltip.init(elems, {});

          var elem = document.querySelectorAll('.tabs');
          var instances = M.Tabs.init(elem, {});

          this.bdReadCVs();
     },
     computed: {
          elporcentaje() {
               return this.porcentaje;
          },
          /* Filtra las tareas cuando la búsqueda es por descripción o responsable */
          filtrarCVs: function () {
               // console.log("[ filtrarCVs ]");
               // console.log(this.CVs)
               return this.CVs.filter((cv, index) => {


                    /* Preserva el índice las tareas recién instanciadas ya que cuando se realiza una búsqueda y se quiere 
                       eliminar una tarea, el índice cambia y borra otra tarea. [ Ver función eliminar() ] en tareas.vue.   && (usuario.activo===this.activos)   */
                    // tarea.codigo = index;
                    if (cv.nombre.toUpperCase().includes(this.busqueda.toUpperCase())) {
                         return cv
                    }
               })
          }, // filtarTareas()    (usuario.administrador===this.administradores)
     },
     methods: {

          limpiar() {
               this.exito = false;
               this.agrabar = false;

               this.nombre = ""; this.direccion = ""; this.movil = "";
               this.email = ""; this.sexo = "";
               this.edad= 0, this.profesion= "", this.puesto= "", this.ecivil= "",
               this.selectedFile = ""; this.selectedFoto = "";
               this.urlfoto = "", this.urlcv = "";
          },
          /** .*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.* */
               verjspdf() {
                    /** */
                    var nArchivo = "demo"

                    var doc = new jsPDF();

                    doc.setFontSize(40);
                    doc.text("Octonyan loves jsPDF", 35, 25);

                    // Set the document to automatically print via JS
                    doc.save(nArchivo);
                    doc.autoPrint();
                    window.open(doc.output('bloburl'), '_blank');

                    // doc.output('dataurlnewwindow');               
               },
          /** .*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.* */
          password: function (updatePassword, reason) {

               updatePassword(prompt('password is "test"'));
          },
          error: function (err) {

               console.log(err);
          },             
          verPDF(seleccionado,vieneurl) {

               // console.log("pdfdocument ", this.src);
               vieneurl = vieneurl.trim();
               this.currCV = vieneurl;
               this.pdfdata = vieneurl;
               this.src       = vieneurl;
               console.log("$#$#$#$#$#$#$#$#$#$#$#$#$#$#$#$#$#$#$#$#$#$#$#$#$#$#$#");
               console.log("[verPDF], url ? ",vieneurl);
               console.log("[verPDF], currCV ? ", this.src);

               // this.getPdf();
          },
          verFoto(imagen, url) {

               url = url.trim();
               console.log("URL ? ", url)
               var currFoto = '<img src="' + url + '">';
               this.currFotoT = url;
               this.currFoto = currFoto;
          },
          /** .*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.* */
          deleteCV(elNombre, laLlave) {

               const self = this;

               var confirma = confirm("Seguro de eliminar el CV ? " + elNombre + "(" + laLlave + ")");
               if (confirma === true) {

                    /* Borra del nodo /usuarios al usuario deseado */
                    self.borrarCV(laLlave);      // También se borra el usuario del nodo /usuarios
               } // if(confirma)
          }, // deleteUser()
          borrarCV(laLlave) {

               var lanuevaRuta = store.state.st_rutaCVs + '/' + laLlave;
               var dbelCV = store.state.st_db.ref(lanuevaRuta);

               var elRegEmpresa = dbelCV.remove();

               this.bdReadCVs();
          }, // borrarTarea()            

          /** .*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.* */
          agregaCV() {

               var llargoNombre = this.nombre.trim().length;
               var llargocvs = this.selectedFile.name.trim().length;
               var llargofoto = this.selectedFoto.name.trim().length;

               if (llargoNombre === 0 || llargocvs === 0 || llargofoto === 0) {

                    alert("Debe ingresar un nombre de participante, seleccionar un cvs y una foto !");
               } else {

                    var confirma = confirm("Seguro de agregar el participante " + this.nombre + " ?");
                    if (confirma === true) {

                         this.cargarCVyFoto();
                    } // if confirma()
               } // if this.nombre

               this.ver = false;

               this.bdReadCVs();
          },
          grabaParticipante(laurlfoto, laurlcv) {

               this.ladbCVs = store.state.st_dbCVs;
               this.ladbCVs.push({

                    nombre: this.nombre, direccion: this.direccion, movil: this.movil,
                    email: this.email, sexo: this.sexo,
                    edad: this.edad, profesion: this.profesion, puesto: this.puesto, ecivil: this.ecivil,
                    cfoto: this.selectedFoto.name, ccv: this.selectedFile.name,
                    urlfoto: laurlfoto, urlcv: laurlcv,
               }).then(() => {

                    /* Inicializa las variables que captan los valores para el nuevo fcapturadatos */
                    this.nombre = ""; this.direccion = ""; this.movil = "";
                    this.email = ""; this.sexo = "";
                    this.edad = 0, this.profesion = "", this.puesto = "", this.ecivil = "",
                    this.selectedFile = ""; this.selectedFoto = "";
                    this.urlfoto = "", this.urlcv = "";

                    this.agrabar = false; this.exito = false;
               });
          },

          /** .*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.* */
          getCV(losCVs) {

               this.CVs = [];
               this.limite = 0;

               /* Tipología = Myers */
               for (let key in losCVs) {
                    this.CVs.push({

                         llave: key,                                             // 1
                         nombre: losCVs[key].nombre, direccion: losCVs[key].direccion,
                         movil: losCVs[key].movil, email: losCVs[key].email,
                         sexo: losCVs[key].sexo,
                         edad: losCVs[key].edad,
                         profesion: losCVs[key].profesion,
                         puesto: losCVs[key].puesto,
                         ecivil: losCVs[key].ecivil,
                         cfoto: losCVs[key].cfoto, ccv: losCVs[key].ccv,
                         urlfoto: losCVs[key].urlfoto, urlcv: losCVs[key].urlcv,
                    })
               } // for
          },
          bdReadCVs() {

               var dummy = store.state.st_dbCVs.on('value', snapshot =>
                    this.getCV(snapshot.val()));

          },

          /** .*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.* */
          /** Funciones para cargar un archivo a storage */
          onFileSelected(event) {
               console.log(event);
               this.selectedFile = event.target.files[0];
               console.log("Archivo seleccionado: ", this.selectedFile.name);
          },
          onFileSelectedF(event) {
               console.log(event);
               this.selectedFoto = event.target.files[0];
               console.log("Archivo seleccionado: ", this.selectedFoto.name);
          },
          cargarCVyFoto() {

               this.subirFoto(store.state.st_rutaFotosU, this.selectedFoto);

               this.subirCV(store.state.st_rutaCVs, this.selectedFile);
          },
          subirFoto(laruta, seleccionado) {

               console.log("la ruta: ",laruta);
               console.log("seleccionado ? ",seleccionado);
               this.mostrarCargador = true;
               this.porcentaje = 0;

               /** Obtiene el archivo seleccionado en "file" y establece en "hijo" la nueva ruta de acceso que incluye 
                *  solo el nombre del archivo seleccionado.  */
               var file = seleccionado;
               var hijo = laruta + seleccionado.name;

               /** Referencia a la carpeta donde estarán los CVs */
               var storageRef = store.state.st_stg.ref(hijo);

               /** Graba el archivo seleccionado en la carpeta correspondiente en storage */
               var uploadTaskFoto = storageRef.put(file);

               // Listen for state changes, errors, and completion of the upload.
               var self = this;

               uploadTaskFoto.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
                    function (snapshot) {
                         // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                         var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                         self.porcentaje = Math.round(progress);
                         console.log('Upload is ' + progress + '% done');
                         switch (snapshot.state) {
                              case firebase.storage.TaskState.PAUSED: // or 'paused'
                                   console.log('Upload is paused');
                                   break;
                              case firebase.storage.TaskState.RUNNING: // or 'running'
                                   console.log('Upload is running');
                                   break;
                         } // switch
                    }, // function(snapshot)
                    function (error) {

                         // A full list of error codes is available at
                         // https://firebase.google.com/docs/storage/web/handle-errors
                         switch (error.code) {
                              case 'storage/unauthorized':
                                   // User doesn't have permission to access the object
                                   break;

                              case 'storage/canceled':
                                   // User canceled the upload
                                   break;

                              case 'storage/unknown':
                                   // Unknown error occurred, inspect error.serverResponse
                                   break;
                         } // switch
                    }, // function(error)
                    function () {
                         // Upload completed successfully, now we can get the download URL
                         uploadTaskFoto.snapshot.ref.getDownloadURL()
                              .then(function (downloadURL) {

                                   store.state.st_urlfoto = downloadURL;

                                   self.mostrarCargador = false;
                                   self.exito = true;

                                   self.urlfoto = store.state.st_urlfoto;
                              });
                    } // function()
               ); // uploadTaskFoto()
          }, // subir
          subirCV(laruta, seleccionado) {

               this.mostrarCargador = true;
               this.porcentaje = 0;

               /** Obtiene el archivo seleccionado en "file" y establece en "hijo" la nueva ruta de acceso que incluye 
                *  solo el nombre del archivo seleccionado.  */
               var file = seleccionado;
               var hijo = laruta + seleccionado.name;

               /** Referencia a la carpeta donde estarán los CVs */
               var storageRef = store.state.st_stg.ref(hijo);

               /** Graba el archivo seleccionado en la carpeta correspondiente en storage */
               var uploadTaskCV = storageRef.put(file);

               // Listen for state changes, errors, and completion of the upload.
               var self = this;

               uploadTaskCV.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
                    function (snapshot) {
                         // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                         var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                         self.porcentaje = Math.round(progress);
                         console.log('Upload is ' + progress + '% done');
                         switch (snapshot.state) {
                              case firebase.storage.TaskState.PAUSED: // or 'paused'
                                   console.log('Upload is paused');
                                   break;
                              case firebase.storage.TaskState.RUNNING: // or 'running'
                                   console.log('Upload is running');
                                   break;
                         } // switch
                    }, // function(snapshot)
                    function (error) {
                         // A full list of error codes is available at
                         // https://firebase.google.com/docs/storage/web/handle-errors
                         switch (error.code) {
                              case 'storage/unauthorized':
                                   // User doesn't have permission to access the object
                                   break;
                              case 'storage/canceled':
                                   // User canceled the upload
                                   break;
                              case 'storage/unknown':
                                   // Unknown error occurred, inspect error.serverResponse
                                   break;
                         } // switch
                    }, // function(error)
                    function () {
                         // Upload completed successfully, now we can get the download URL
                         uploadTaskCV.snapshot.ref.getDownloadURL()
                              .then(function (downloadURL) {

                                   store.state.st_urlcv = downloadURL;
                                   self.urlcv = store.state.st_urlcv;

                                   self.mostrarCargador = false;
                                   self.exito = true;

                                   self.grabarFB(self.urlfoto, self.urlcv);
                              });
                    } // function()
               ); // uploadTaskCV()
          }, // subir
          grabarFB(uno, dos) {

               this.urlfoto = uno; this.urlcv = dos;
               this.grabaParticipante(this.urlfoto, this.urlcv);
          },
     } // methods
} //


// WEBPACK FOOTER //
// ./src/pruebas/cvs.js